import { call, getContext, put, select } from 'redux-saga/effects';
import { loadPublishTermsSuccess, loadPublishTermsFail } from '../../../reducers';
import { IAppState } from '../../../types';
import {
  IServicePickerWidgetMicrofrontendAPI,
  TLoadPublishTermsResult,
} from '../../../../types/microfrontends/servicePickerWidget';
import { debounce } from 'lodash';
import { selectUserId } from '../../../../selectors/user';

const loadPublishTerms = async (
  servicePickerWidgetMicrofrontend: IServicePickerWidgetMicrofrontendAPI | undefined,
  state: IAppState,
) => {
  await servicePickerWidgetMicrofrontend?.setOffer(state.offer);
  await servicePickerWidgetMicrofrontend?.setUser(state.user);

  return servicePickerWidgetMicrofrontend?.loadPublishTerms();
};

const debouncedLoadPublishTerms = debounce(loadPublishTerms, 1000, { leading: true, trailing: true });

export function* getPublishTerms() {
  try {
    const state: IAppState = yield select();
    const userId: number | undefined = yield select(selectUserId);

    if (!userId) {
      return;
    }

    const servicePickerWidgetMicrofrontend: IServicePickerWidgetMicrofrontendAPI | undefined = yield getContext(
      'servicePickerWidgetMicrofrontend',
    );

    const data: TLoadPublishTermsResult | null = yield call(
      debouncedLoadPublishTerms,
      servicePickerWidgetMicrofrontend,
      state,
    );

    if (data && data.success) {
      yield put(loadPublishTermsSuccess(data.payload));
    } else {
      yield put(loadPublishTermsFail());
    }
  } catch (e) {
    yield put(loadPublishTermsFail());

    throw new Error(e.toString());
  }
}
